/**
 * Formats an ISO timestamp string into a human-readable relative/absolute format.
 *
 * Rules:
 * - < 1 minute  → "Just now"
 * - < 1 hour    → "X minutes ago"
 * - < 24 hours  → "X hours ago"
 * - < 7 days    → "X days ago"
 * - >= 7 days   → "Mar 15, 2025"
 */
export function formatEventTimestamp(isoString: string): string {
	const date = new Date(isoString);
	const now = new Date();
	const diffMs = now.getTime() - date.getTime();
	const diffMinutes = Math.floor(diffMs / (1000 * 60));
	const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
	const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

	const dateStr = date.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		year: "numeric"
	});

	if (diffMinutes < 1) {
		return "Just now";
	}
	if (diffMinutes < 60) {
		return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
	}
	if (diffHours < 24) {
		return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
	}
	if (diffDays < 7) {
		return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
	}
	return dateStr;
}
